import { render } from "./MovieCardItem.vue?vue&type=template&id=350562c8&scoped=true"
import script from "./MovieCardItem.vue?vue&type=script&lang=js"
export * from "./MovieCardItem.vue?vue&type=script&lang=js"

import "./MovieCardItem.vue?vue&type=style&index=0&id=350562c8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350562c8"]])

export default __exports__